module.exports = __webpack_public_path__ + "static/media/Mad Gaze.f6a76f72.png";